















































import Component, { mixins } from "vue-class-component";
import { Ref } from "vue-property-decorator";
import AxiosMixin from "@/mixins/axiosMixin";
import LoadingDialog from "@/components/common/LoadingDialog.vue";
import CareSpecificationRev1 from "@/components/careEdit/specification/CareSpecificationRev1.vue";
import CareInvoiceRev1 from "@/components/careEdit/invoice/CareInvoiceRev1.vue";

import {
  CareSpecificationDetail,
  CareSpecificationAggregate,
  CareInvoice,
  CareSpecification,
  InnerCareSpecification
} from "@/components/careEdit/types";
import { SelectItem, PulldownItem } from "@/types";

@Component({
  components: {
    LoadingDialog,
    CareSpecificationRev1,
    CareInvoiceRev1
  }
})
export default class CareEdit extends mixins(AxiosMixin) {
  @Ref("careinvoice") private readonly invoiceTab!: CareInvoiceRev1; //明細編集ダイアログ

  private invoice: CareInvoice | null = null; //利用者向け請求書データ
  private specifications: CareSpecification[] = []; //介護給付費データ
  private sex_items: SelectItem[] = []; //性別選択アイテムリスト
  private stop_reason_items: SelectItem[] = []; //中止理由選択アイテムリスト
  private tax_items: PulldownItem[] = []; //税率選択アイテムリスト
  private selectTabItem = 0; //選択中のタブ
  private isTrial = window.is_trial;
  private isLoaded = false; // ロード完了フラグ

  mounted() {
    this.updateData();
  }

  //データ取得
  private updateData() {
    this.postJsonCheck(
      window.base_url + "/api/office/care/edit/get_one",
      {
        patient_id: Number(this.$route.params.id),
        patient_name: String(this.$route.query.patient_name),
        specification_id: Number(this.$route.query.specification_id),
        yearmonth: this.$route.query.yearmonth
      },
      res => {
        this.specifications = res.data.specifications;
        this.invoice = res.data.invoice;
        this.sex_items = res.data.sex_items;
        this.stop_reason_items = res.data.stop_reason_items;
        this.tax_items = res.data.tax_items;
        this.selectTabItem = res.data.select_tab;

        this.$nextTick(() => {
          this.isLoaded = true;
        });
      }
    );
  }

  //キャンセル
  private cancel() {
    this.$router.go(-1);
  }

  //保存
  private save() {
    if (!confirm("データを保存しますか？")) {
      return;
    }

    const specifications: InnerCareSpecification[] = [];
    let details: CareSpecificationDetail[] = [];
    let aggregates: CareSpecificationAggregate[] = [];
    this.specifications.forEach(specification => {
      for (let index = 0; index < specification.public_moneys.length; index++) {
        const pm = specification.public_moneys[index];

        const oneDetails: CareSpecificationDetail[] = [];
        for (let i = 0; i < pm.public_money_details.length; i++) {
          const detail = { ...specification.specification_details[i] };
          const md = pm.public_money_details[i];
          detail.service_code = Number(detail.service_code);
          detail.points = Number(detail.points);
          detail.count = Number(detail.count);
          detail.service_points = Number(detail.service_points);
          detail.id = md.id;
          detail.care_specification_id = md.care_specification_id;
          detail.public_money_count = Number(md.public_money_count);
          detail.public_money_points = Number(md.public_money_points);
          detail.summary = md.summary;
          oneDetails.push(detail);
        }
        details = details.concat(oneDetails);

        const oneAggregates: CareSpecificationAggregate[] = [];
        for (let i = 0; i < pm.public_money_aggregates.length; i++) {
          const aggregate = { ...specification.specification_aggregates[i] };
          const ma = pm.public_money_aggregates[i];
          aggregate.service_type_kind_code = Number(
            aggregate.service_type_kind_code
          );
          aggregate.service_actual_days = Number(aggregate.service_actual_days);
          aggregate.plan_points = Number(aggregate.plan_points);
          aggregate.target_points = Number(aggregate.target_points);
          aggregate.non_target_points = Number(aggregate.non_target_points);
          aggregate.payment_points = Number(aggregate.payment_points);
          aggregate.point_place = Number(aggregate.point_place);
          aggregate.plan_points_above_money = Number(
            aggregate.plan_points_above_money
          );
          aggregate.id = ma.id;
          aggregate.care_specification_id = ma.care_specification_id;
          aggregate.public_money_points = Number(ma.public_money_points);
          aggregate.ins_invoice = Number(ma.ins_invoice);
          aggregate.patient_burden = Number(ma.patient_burden);
          aggregate.public_money_invoice = Number(ma.public_money_invoice);
          aggregate.public_money_self_burden = Number(
            ma.public_money_self_burden
          );
          oneAggregates.push(aggregate);
        }
        aggregates = aggregates.concat(oneAggregates);

        const s = { ...specification };
        s.insured_birthday = this.toResTime(s.birth_day_str);
        s.insured_sex = Number(s.insured_sex);
        s.insured_care_status = Number(s.insured_care_status);
        s.insured_valid_start_date = this.toResTime(
          s.insured_valid_start_date_str
        );
        s.insured_valid_end_date = this.toResTime(s.insured_valid_end_date_str);
        s.start_date = this.toResTime(s.start_date_str);
        s.stop_date = this.toResTime(s.stop_date_str);
        s.stop_reason = Number(s.stop_reason);
        s.id = pm.id;
        s.related_care_specification_id = pm.related_care_specification_id;
        s.public_money_code = pm.public_money_code;
        s.public_money_law_number = pm.public_money_law_number;
        s.public_money_name = pm.public_money_name;
        s.public_money_self_burden = pm.public_money_self_burden;
        s.bear_number = pm.bear_number;
        s.recipient_number = pm.recipient_number;
        s.insurance_rate = Number(pm.insurance_rate);
        s.public_money_rate = Number(pm.public_money_rate);
        s.summary_insurance_money = Number(pm.summary_insurance_money);
        s.summary_patient_burden_money = Number(
          pm.summary_patient_burden_money
        );
        s.summary_public_money = Number(pm.summary_public_money);
        s.summary_public_money_patient_burden = Number(
          pm.summary_public_money_patient_burden
        );
        specifications.push(s);
      }
    });

    //合計額に算入済みの限度額超過分（BFFが差し引いてBFF算出値を入れ直す）
    let invoiceAboveLimitMoney = 0;
    if (this.invoice != null) {
      this.invoice.all_self_burden1_money = Number(
        this.invoice.all_self_burden1_money
      );
      this.invoice.all_self_burden2_money = Number(
        this.invoice.all_self_burden2_money
      );
      this.invoice.all_self_burden3_money = Number(
        this.invoice.all_self_burden3_money
      );
      this.invoice.other1_money = Number(this.invoice.other1_money);
      this.invoice.other1_tax = Number(this.invoice.other1_tax);
      this.invoice.other2_money = Number(this.invoice.other2_money);
      this.invoice.other2_tax = Number(this.invoice.other2_tax);
      this.invoice.other3_money = Number(this.invoice.other3_money);
      this.invoice.other3_tax = Number(this.invoice.other3_tax);
      this.invoice.other4_money = Number(this.invoice.other4_money);
      this.invoice.other4_tax = Number(this.invoice.other4_tax);
      this.invoice.other5_money = Number(this.invoice.other5_money);
      this.invoice.other5_tax = Number(this.invoice.other5_tax);
      this.invoice.total_money = this.invoiceTab.allTotal;
      this.invoice.tax8_money = this.invoiceTab.allTax8;
      this.invoice.tax10_money = this.invoiceTab.allTax10;
      this.invoice.deduction_money = Number(this.invoice.deduction_money);
      invoiceAboveLimitMoney = this.invoiceTab.aboveLimitTotal;
    }

    this.postJsonCheck(
      window.base_url + "/api/office/care/edit/update",
      {
        specifications: specifications,
        specification_details: details,
        specification_aggregates: aggregates,
        invoice: this.invoice,
        invoice_above_limit_money: invoiceAboveLimitMoney,
        patient_id: Number(this.$route.params.id),
        patient_name: String(this.$route.query.patient_name)
      },
      () => {
        this.cancel();
      }
    );
  }

  //日時変換
  private toResTime(datetime: string): string | null {
    return datetime ? new Date(datetime).toISOString() : null;
  }
}
